import React from "react";
import { PieChart } from "lucide-react";

const DepartmentChart = ({ styles, text, language, departmentStats, totalAcrossDepartments, screenSize }) => {
  return (
    <div style={styles.chartCard}>
      <h3 style={styles.cardTitle}>
        <PieChart size={screenSize.isMobile ? 18 : 20} />
        {text[language].departmentStats}
      </h3>
      <div style={styles.chartContainer}>
        {departmentStats.map((dept, index) => (
          <div key={index} style={styles.chartBar}>
            <div style={styles.chartBarInfo}>
              <div
                style={{ ...styles.chartBarColor, background: dept.color }}
              />
              <span style={styles.chartBarLabel}>{dept.name}</span>
            </div>
            <div style={styles.chartBarProgress}>
              <div
                style={{
                  ...styles.chartBarFill,
                  background: dept.color,
                  width: `${dept.percentage}%`,
                }}
              />
            </div>
            <div style={styles.chartBarValue}>
              {dept.count} ({dept.percentage}%)
            </div>
          </div>
        ))}
      </div>

      <div style={styles.chartSummary}>
        <div>
          <span style={styles.chartSummaryText}>
            {text[language].totalAcrossDepts}
          </span>
        </div>
        <div style={styles.chartSummaryValue}>
          {totalAcrossDepartments} {" "}
          {text[language].employees}
        </div>
      </div>
    </div>
  );
};

export default DepartmentChart;